// Server-side fraud-prevention writes silent_duplicate: true onto feedback_collection
// docs that were submitted via a duplicate phone number.  These should never
// count toward KPIs, charts, leaderboards, or exports — only the dedicated
// admin "Silent Duplicates" view.
//
// Pre-deployment docs don't have the field at all, so we check === true (not
// truthy) to include legitimate historical rows.

export const isSilentDuplicate = (data) => data?.silent_duplicate === true;

export const isLegitimateFeedback = (data) => !isSilentDuplicate(data);

/**
 * Filters a snapshot's docs to legitimate feedback only.
 * Use after `snap.docs` and before `.map(shape)`.
 */
export const filterLegitimateDocs = (docs) =>
  docs.filter((d) => isLegitimateFeedback(d.data ? d.data() : d));

/**
 * Filters an already-shaped array (with `silent_duplicate` preserved).
 */
export const filterLegitimateRows = (rows) =>
  rows.filter((r) => !r?.silent_duplicate);
